<template>
  <div class="row">
    <!-- car offers  -->
    <div
      class="col-lg-4 col-md-6 col-12"
      v-for="car in visibleCars"
      :key="car.id"
      data-aos="fade-down"
    >
      <div class="listing-item">
        <!-- imgs -->
        <div class="listing-img">
          <router-link
            :to="`/listing/${car.id}`"
            v-if="car.images?.length === 1"
          >
            <img
              :src="
                car.images?.[0]?.image ||
                require('@/assets/img/cars/no-car.jpg')
              "
              class="img-fluid"
              :alt="car.brand?.name"
            />
          </router-link>

          <!-- sliders -->
          <div v-else-if="car.images?.length > 1">
            <Carousel
              :wrap-around="true"
              :settings="settings"
              :breakpoints="breakpoints"
            >
              <Slide v-for="(slideItem, index) in car.images" :key="index">
                <div class="slide-images">
                  <router-link :to="`/listing/${car.id}`">
                    <img
                      :src="
                        slideItem.image ||
                        require('@/assets/img/cars/no-car.jpg')
                      "
                      class="img-fluid"
                      :alt="car.brand?.name"
                    />
                  </router-link>
                </div>
              </Slide>
              <template #addons>
                <Pagination />
                <Navigation />
              </template>
            </Carousel>
          </div>

          <!-- default if no images-->
          <div v-else>
            <router-link :to="`/listing/${car.id}`">
              <img
                :src="require('@/assets/img/cars/no-car.jpg')"
                class="img-fluid"
                :alt="car.brand?.name"
              />
            </router-link>
          </div>
        </div>

        <!-- rest of details -->
        <div class="listing-content">
          <div
            class="listing-features d-flex align-items-end justify-content-between"
          >
            <div>
              <h3 class="listing-title">
                <router-link :to="`/listing/${car.id}`">
                  {{ car.brand?.name }} {{ car.model?.name }}
                </router-link>
              </h3>
              <div class="list-rating">
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star"></i>
                <span>{{ car.reviews || 0 }}</span>
              </div>
            </div>
            <div class="list-km">
              <span class="km-count">
                <img src="@/assets/img/icons/map-pin.svg" alt="location" />
                {{ formatLocation(car.location) }}
              </span>
            </div>
          </div>

          <div class="listing-details-group">
            <ul>
              <li>
                <span><img src="@/assets/img/icons/car-parts-02.svg" /></span>
                <p>{{ car.km || "غير محدد" }}</p>
              </li>
              <li>
                <span><img src="@/assets/img/icons/car-parts-03.svg" /></span>
                <p>{{ car.fuel_type || "غير محدد" }}</p>
              </li>
            </ul>
          </div>

          <div class="listing-location-details">
            <!-- <div class="listing-price">
              <h6>
                {{ formatPrice(car.price) }}
                <span>/ يوم</span>
              </h6>
            </div> -->
            <div class="listing-price">
              <span v-if="car.rent_or_sale == 'rent'">ايجار</span>
              <span v-else-if="car.rent_or_sale == 'installment'">تقسيط</span>
              <span v-else>كاش</span>
            </div>
            <div class="listing-price">
              <h6 v-if="car.rent_or_sale == 'rent'">
                ${{ car.price?.daily }}
                <span>/ يوم</span>
              </h6>
              <h6 v-else-if="car.rent_or_sale == 'installment'">
                ${{ car.installment?.price }}
              </h6>
              <h6 v-else>${{ car.price }}</h6>
            </div>
          </div>

          <div class="listing-button">
            <!-- <router-link :to="`/listing/${car.id}`" class="btn btn-order">
              <span><i class="feather-calendar me-2"></i></span>شوف تفاصيل
            </router-link> -->
            <router-link :to="'/listing/' + car.id" class="btn btn-order"
              ><span><i class="feather-calendar me-2"></i></span>شوف تفاصيل
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- See More btns-->
    <div class="col-12 text-center mt-4" v-if="cars.length > visibleCount">
      <button class="btn btn-primary btn-view-car" @click="visibleCount += 6">
        عرض المزيد
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

const props = defineProps({
  cars: {
    type: Array,
    default: () => [],
  },
});

const visibleCount = ref(6);

watch(
  () => props.cars,
  () => {
    visibleCount.value = 6;
  }
);

const visibleCars = computed(() => props.cars.slice(0, visibleCount.value));

const settings = {
  itemsToShow: 1,
  snapAlign: "center",
};

const breakpoints = {
  575: { itemsToShow: 1, snapAlign: "center" },
  767: { itemsToShow: 1, snapAlign: "center" },
  991: { itemsToShow: 1, snapAlign: "center" },
  1024: { itemsToShow: 1, snapAlign: "start" },
};

const formatPrice = (price) => {
  if (typeof price === "number") {
    return price;
  } else if (typeof price === "object" && price !== null) {
    return price.daily ?? 0;
  }
  return 0;
};

const formatLocation = (location) => {
  if (
    !location ||
    (typeof location === "object" && Object.keys(location).length === 0)
  ) {
    return "غير محدد";
  }
  return location;
};
</script>

<style scoped>
.listing-img {
  position: relative;
  overflow: hidden;
}

.listing-img img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 8px;
}

.slide-images img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 8px;
}
.list-rating {
  display: flex;
  align-items: center;
  gap: 3px;
}

.list-rating span {
  margin-left: 4px;
}
</style>
